import { getCookie, removeCookie, setCookie } from "@workspace/cookies/browser";
import { useCallback } from "react";

const TWO_MINUTES = 120000;

const useLoginError = () => {
  const error = getCookie("loginError") ?? "";
  const setError = useCallback(
    (value: string) =>
      setCookie("loginError", value, { expires: getExpireDate() }),
    [],
  );
  return { error, setError, resetError };
};

const resetError = () => removeCookie("loginError");

const getExpireDate = () => new Date(Date.now() + TWO_MINUTES);

export default useLoginError;
